import React, { useEffect, useState } from 'react';
import {Button, Modal, Tree} from 'antd';
import axios from 'axios';
import folderIcon from '../../assets/folder.png';
import './HeliosFolderExplorer.css';
import {getConfig} from "../../config";

interface NodeData {
    key: string;
    title: string;
    isLeaf?: boolean;
    children?: NodeData[];
    level: number;
}

interface ExplorerProps {
    open: boolean;
    onClose: () => void;
    onSelectPath: (path: string) => void;
}

const HeliosFolderExplorer: React.FC<ExplorerProps> = ({ open, onClose, onSelectPath }) => {
    const [treeData, setTreeData] = useState<NodeData[]>([]);
    const [selectedPath, setSelectedPath] = useState<string[]>([]);
    const [expandedKeys, setExpandedKeys] = useState<string[]>([]);
    const { API_BASE_URL } = getConfig();

    const fetchData = async (path: string[]) => {
        const parentPath = path.length > 0 ? path.join(',') : 'null';
        const response = await axios.get(`${API_BASE_URL}/getHeliosFolderStructure?parentPath=${parentPath}`);
        return response.data.map((item: any) => ({
            key: item.key,
            title: item.data.BENENNUNG
                ? `${item.data.NAME} | ${item.data.BENENNUNG}`
                : item.data.NAME,
            level: item.level,
            isLeaf: false,
            children: []
        }));
    };

    const handleLoadData = async (node: any) => {
        const currentPath = node.level === 0
            ? [node.key]
            : [...selectedPath.slice(0, 1), node.key];

        const children = await fetchData(currentPath);

        const updateTree = (nodes: NodeData[]): NodeData[] => {
            return nodes.map(n => {
                if (n.key === node.key) {
                    return { ...n, children };
                }
                if (n.children) {
                    return { ...n, children: updateTree(n.children) };
                }
                return n;
            });
        };

        setTreeData(updateTree(treeData));
    };

    const handleSelect = (selectedKeys: React.Key[], info: any) => {
        const newPath = info.node.level === 0
            ? [info.node.key]
            : [...selectedPath.slice(0, 1), info.node.key];

        setSelectedPath(newPath);
    };

    useEffect(() => {
        if (open) {
            fetchData([]).then(setTreeData);
            setSelectedPath([]);
            setExpandedKeys([]);
        }
    }, [open]);


    return (
        <Modal
            open={open}
            onCancel={onClose}
            title="Helios Explorer"
            width={700}
            bodyStyle={{ maxHeight: '60vh', overflowY: 'auto', padding: '16px' }}
            footer={[
                <Button key="search" type="primary" onClick={() => console.log('Suche')}>
                    Zugehörigen Ordner automatisch suchen
                </Button>,
                <Button key="cancel" onClick={onClose}>
                    Abbrechen
                </Button>,
                <Button
                    key="select"
                    type="primary"
                    disabled={selectedPath.length === 0}
                    onClick={() => {
                        const lastPath = selectedPath[selectedPath.length - 1];
                        const heliosUrl = `helios://show-project-by-id?${lastPath}`;
                        onSelectPath(heliosUrl);
                        onClose();
                    }}
                >
                    OK
                </Button>
            ]}
        >
            <Tree
                treeData={treeData}
                fieldNames={{ title: 'title', key: 'key', children: 'children' }}
                loadData={handleLoadData}
                onSelect={handleSelect}
                showIcon
                icon={() => (
                    <img
                        src={folderIcon}
                        alt="folder"
                        style={{ width: 16, height: 16, marginRight: 4 }}
                    />
                )}
            />
        </Modal>
    );
};

export default HeliosFolderExplorer;